









































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';

import MobileFilter from '@/components/MobileFilter.vue';
import ModalItem from '@/components/inventory/ModalItem.vue';
import ModalStatusPending from '@/components/inventory/ModalStatusPending.vue';
import MultiSelect from '@/components/MultiSelect.vue';

import * as c_Interface from '@/interface/components/inventory';
import * as s_Interface from '@/interface/store/inventory';
import Sortable from 'sortablejs';
import moment from 'moment';

const namespace: string = 'inventory';

@Component({
  components: {
    ModalItem,
    ModalStatusPending,
    MultiSelect,
    MobileFilter,
  },
})
export default class Inventory extends Vue {
  @Prop({ type: Boolean }) isFilterOn!: boolean;

  @Action('getInventory', { namespace }) c_getInventory!: any;
  @Action('bulkDeleteInventory', { namespace }) c_bulkDeleteInventory!: any;
  @Action('bulkSetInventory', { namespace }) c_bulkSetInventory!: any;
  @Action('bulkSetRequest', { namespace: 'request' }) c_bulkSetRequest!: any;
  @Action('updateQueryParams', { namespace }) c_updateQueryParams!: any;

  @Mutation('IS_MOBILE_FILTER_PAGE_UP') c_IS_MOBILE_FILTER_PAGE_UP!: any;

  @Getter('getterDataTotalCount', { namespace }) c_getterDataTotalCount!: number | null;
  @Getter('getterInventoryFilter', { namespace })
  c_getterInventoryFilter!: s_Interface.Inventory;
  @Getter('getterDataList', { namespace }) c_getterDataList!: s_Interface.InventoryItem[];
  @Getter('getterQueryParams', { namespace })
  readonly c_getterQueryParams!: s_Interface.InventoryQueryParams;
  @Getter('getterIsMobileFilterPageUp') c_getterIsMobileFilterPageUp!: boolean;
  @Getter('getterIsMobileFilterOn') c_getterIsMobileFilterOn!: boolean;

  public inventoryAttributes: string =
    'id,name,serialNumber,catalogNumber,unit,unitSize,quantity,price,ownedBy,url,casNumber,lotNumber,expiresOn,technicalDetails,boughtFrom,expirationReminder,customFields,vendorName,manufacturerName,isArchived,createdBy,createdAt,updatedBy,updatedAt,lastReceivedAt,fkTypeId,fkVendorId,fkManufacturerId,fkLocationId,fkLocationSubId,notes';
  public inventoryLimit: number = 20;
  public inventoryOffset: number = 0;
  public inventoryCurrentPage: number = 1;
  public inventorySort = '-updatedAt';
  public inventoryInclude: string =
    'fkType,fkVendor,fkManufacturer,fkLocation,fkLocationSub,fkOwnedBy';
  public inventoryKeyword: string = '';
  public defaultSort = { prop: 'updatedAt', order: 'descending' };
  public dropHeader: (c_Interface.DropHeader | undefined)[] = [];

  public behaviorStatus = '';
  public headers: c_Interface.DropHeader[] = [
    {
      type: 'selection',
      label: '',
      prop: '',
      sortable: false,
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '물품명',
      prop: 'name',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '판매처',
      prop: 'fkVendor.name',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '제조사',
      prop: 'fkManufacturer.name',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '카탈로그 번호',
      prop: 'catalogNumber',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '재고수량',
      prop: 'quantity',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '보관위치',
      prop: 'fkLocation.name',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '타입',
      prop: 'fkType.name',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '단위',
      prop: 'unitSize',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '단가',
      prop: 'price',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '등록자',
      prop: 'fkOwnedBy.fullName',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '등록일',
      prop: 'createdAt',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '수정일',
      prop: 'updatedAt',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: 'Lot 번호',
      prop: 'lotNumber',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: 'URL',
      prop: 'url',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '유효기간 만료일',
      prop: 'expiresOn',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: 'CAS 번호',
      prop: 'casNumber',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
    {
      type: '',
      label: '고유 번호',
      prop: 'id',
      sortable: 'custom',
      sortOrders: ['ascending', 'descending'],
    },
  ];
  public behaviorStatusItem = [
    { label: '구매요청', value: 'request' },
    { label: '복사', value: 'duplicate' },
    { label: '삭제', value: 'delete' },
  ];
  public setLayerItems = [
    { label: '물품명', value: 'name' },
    { label: '판매처', value: 'fkVendor.name' },
    { label: '제조사', value: 'fkManufacturer.name' },
    { label: '카탈로그 번호', value: 'catalogNumber' },
    { label: '재고수량', value: 'quantity' },
    { label: '보관위치', value: 'fkLocation.name' },
    { label: '타입', value: 'fkType.name' },
    { label: '단위', value: 'unitSize' },
    { label: '단가', value: 'price' },
    { label: '등록자', value: 'fkOwnedBy.fullName' },
    { label: '등록일', value: 'createdAt' },
    { label: '수정일', value: 'updatedAt' },
    { label: 'Lot 번호', value: 'lotNumber' },
    { label: 'URL', value: 'url' },
    { label: '유효기간 만료일', value: 'expiresOn' },
    { label: 'CAS 번호', value: 'casNumber' },
    { label: '고유 번호', value: 'id' },
  ];
  public chkList: Array<string> = [];
  public isUp: boolean = false;
  public selectedIds: Array<string> = [];
  public selectedItems: c_Interface.SelectedItem[] = [];
  public dialogVisible: boolean = false;
  public dialogVisibleStatus: boolean = false;
  public orderStatusItems: c_Interface.OrderStatusItem[] = [];
  public searchKeyword: string | (string | null)[] = '';
  public sortable: Sortable | null = null;
  public dataList: s_Interface.InventoryItem[] = [];
  public dateCtx = moment;

  created() {
    this.chkList = this.c_getterQueryParams.attributes.split(',');
    const keyword = this.$route.query.query;
    this.searchKeyword = keyword ? keyword : '';
  }

  mounted() {
    this.$root.$on('rootEmitAddInventoryItem', () => {
      this.dialogVisible = true;
    });
  }

  @Watch('c_getterQueryParams', { deep: true })
  async onGroupIdChange(groupId: string, oldGroupId: string) {
    this.chkList = this.c_getterQueryParams.attributes.split(',');
  }

  toggleFilterPage() {
    this.c_IS_MOBILE_FILTER_PAGE_UP(!this.c_getterIsMobileFilterPageUp);
  }

  addInventoryItem() {
    if (this.$route.params.groupId === 'welcome') {
      this.$message.warning('LAB을 생성해주세요.');
      return false;
    }
    this.$root.$emit('rootEmitAddInventoryItem');
  }

  async statusProcess(str: string) {
    const groupId: string = this.$route.params.groupId;
    switch (str) {
      case 'request':
        const statusPayload = this.selectedItems.map((item: c_Interface.SelectedItem) => {
          return {
            id: item.id,
            name: item.name,
            catalogNumber: item.catalogNumber,
            fkVendorId: item.fkVendorId,
            fkManufacturerId: item.fkManufacturerId,
            fkTypeId: item.fkTypeId,
            status: 'PENDING',
            notes: null,
            price: item.price,
            quantity: item.quantity,
            requestedBy: item.ownedBy,
            url: item.url,
            unitSize: item.unitSize,
            typeName: item.fkType.name,
            vendorName: item.fkVendor && item.fkVendor.name,
            manufacturerName: item.fkManufacturer && item.fkManufacturer.name,
          };
        });
        await this.onOrderStatus(statusPayload);
        this.behaviorStatus = '';
        break;
      case 'duplicate':
        this.$confirm(`${this.selectedIds.length}건의 물품을 복사 하시겠습니까?`, '복사하기', {
          confirmButtonText: `${this.selectedIds.length}건 복사하기`,
          cancelButtonText: '취소',
          type: 'success',
        })
          .then(async () => {
            try {
              const payload = this.selectedItems.map((item: c_Interface.SelectedItem) => {
                delete item.id;
                delete item.createdAt;
                delete item.updatedAt;
                return item;
              });
              await this.c_bulkSetInventory({
                groupId,
                payload,
              });
              await this.initLoad();
              this.behaviorStatus = '';
              this.$message.success(`${this.selectedIds.length}건의 물품을 복사하였습니다.`);
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            this.behaviorStatus = '';
            console.log(e);
          });
        break;
      case 'delete':
        this.$confirm(`${this.selectedIds.length}건의 물품을 삭제 하시겠습니까?`, '물품 삭제하기', {
          confirmButtonText: `${this.selectedIds.length}건 삭제하기`,
          cancelButtonText: '취소',
          type: 'success',
        })
          .then(async () => {
            try {
              await this.c_bulkDeleteInventory({
                groupId,
                payload: this.selectedIds,
              });
              await this.initLoad();
              this.behaviorStatus = '';
              this.$message.success(`${this.selectedIds.length}건의 물품을 삭제하였습니다.`);
            } catch (e) {
              console.log(e);
              this.$message.error(e.response.data.error.message);
            }
          })
          .catch((e) => {
            this.behaviorStatus = '';
            console.log(e);
          });
        break;
    }
  }

  onCurrentSelected(selection: c_Interface.SelectedItem[]) {
    this.selectedItems = selection;
    this.selectedIds = selection.map((item: c_Interface.SelectedItem) => item.id);
  }

  onOrderStatus(payload: c_Interface.OrderStatusItem[]) {
    this.dialogVisibleStatus = true;
    this.orderStatusItems = payload;
  }

  onCurrentColumns() {
    const groupId: string = this.$route.params.groupId;
    const attributes = this.chkList.join();
    const payload = { attributes };

    this.c_updateQueryParams({ groupId, payload });
  }

  get inventoryList() {
    this.dataList = this.c_getterDataList.map((item: s_Interface.InventoryItem) => {
      item.createdAt = this.dateCtx(item.createdAt).format('YYYY-MM-DD HH:mm:ss');
      item.updatedAt = this.dateCtx(item.updatedAt).format('YYYY-MM-DD HH:mm:ss');
      item.expiresOn = item.expiresOn && this.dateCtx(item.expiresOn).format('YYYY-MM-DD');
      return item;
    });
    return this.dataList;
  }

  get dataTotalCount() {
    return this.c_getterDataTotalCount;
  }

  get headersMatch() {
    const result = this.headers
      .map((header: c_Interface.DropHeader) => {
        let match = false;
        this.chkList.forEach((val: string) => {
          if (val === header.prop || header.prop === '') match = true;
        });
        if (match) return header;
      })
      .filter((header: any) => header !== undefined);
    this.dropHeader = [...result];
    return result;
  }

  async initQueryString() {
    const hasLimit = this.$route.query.hasOwnProperty('limit');
    const hasPage = this.$route.query.hasOwnProperty('page');
    const hasSort = this.$route.query.hasOwnProperty('sort');

    const { limit, offset, order } = this.c_getterQueryParams;
    // 쿼리스트링에 한개도 없는지 체크
    if (!Object.keys(this.$route.query).length) {
      const query: any = {
        limit,
        page: offset + 1,
        sort: order,
      };
      await this.$router.replace({ query: Object.assign({}, query) });
      return false;
    } else {
      if (!hasLimit || !hasPage || !hasSort) {
        await this.$router.replace({
          name: 'Inventory',
        });
        return false;
      } else {
        const { limit, page, sort, query }: any = this.$route.query;
        if (limit) {
          this.inventoryLimit = Number(limit);
        }
        if (page) {
          this.inventoryOffset = Number(page) - 1;
          this.inventoryCurrentPage = Number(page);
        }

        if (sort) {
          this.inventorySort = sort;
          if (sort[0] === '-') {
            this.defaultSort = {
              order: 'descending',
              prop: this.inventorySort.substr(1),
            };
          } else {
            this.defaultSort = {
              order: 'ascending',
              prop: this.inventorySort,
            };
          }
        }

        if (query) {
          this.inventoryKeyword = query;
        }

        return true;
      }
    }
  }

  columnDrop(wrapperTr: any) {
    this.sortable = Sortable.create(wrapperTr, {
      animation: 180,
      delay: 0,
      filter: '.label0',
      onMove: (e: any) => !e.related.classList.contains('label0'),
      onEnd: (e: any) => {
        const oldItem = this.dropHeader[e.oldIndex];
        this.dropHeader.splice(e.oldIndex, 1);
        this.dropHeader.splice(e.newIndex, 0, oldItem);
      },
    });
  }

  async initLoad() {
    try {
      this.dropHeader = [...this.headersMatch];
      if (!this.c_getInventory.length) {
        // 쿼리스트링 체크 로직
        const queryCheck = await this.initQueryString();
        const groupId: string = this.$route.params.groupId;
        // 쿼리가 없으면 로직 중지
        if (!queryCheck) return false;
        await this.c_getInventory({
          groupId,
          attributes: this.inventoryAttributes,
          offset: this.inventoryOffset,
          limit: this.inventoryLimit,
          order: this.inventorySort,
          include: this.inventoryInclude,
          query: this.inventoryKeyword,
          filters: this.c_getterInventoryFilter,
        });
      }

      // queryParams 페이지 데이터가 실제로 존재하는 페이지에 없는 경우
      if (this.dataTotalCount) {
        const lastPage =
          this.dataTotalCount <= this.inventoryLimit
            ? 1
            : Math.ceil(this.dataTotalCount / this.inventoryLimit);
        if (this.inventoryCurrentPage > lastPage) {
          await this.$router.replace({
            query: Object.assign({}, this.$route.query, { page: lastPage }),
          });
        }
      }

      this.$nextTick(async () => {
        if (this.inventoryList.length > 0) {
          const wrapperTr: any = document.querySelector('.el-table__header-wrapper tr');
          if (wrapperTr) await this.columnDrop(wrapperTr);
        }
      });
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
    }
  }

  async onModalItemClose({ isVisible, isUpload }: { isVisible: boolean; isUpload: boolean }) {
    this.dialogVisible = isVisible;
    if (isUpload) {
      await this.initLoad();
    }
  }

  get routeKey() {
    let key = this.$route.params.groupId + this.$route.query.page + this.$route.query.limit;

    if (this.$route.query.query) return (key += this.$route.query.query);
    else return key;
  }

  get allColumns() {
    return this.setLayerItems.map((item) => item.value);
  }

  onSearchKeyword(keyword: string | (string | null)[]) {
    // 검색어와 쿼리스트링 같으면 무효화
    if (this.$route.query.query === keyword) return false;
    // 검색 키워드 조회시 무조건 첫번째 페이지로 이동
    this.$route.query.page = '1';
    // 검색 키워드 없으면 초기화
    if (!keyword) {
      // 검색 키워드 텍스트 초기화
      this.searchKeyword = '';
      if (this.$route.query.query) {
        this.$router.push({ query: Object.assign({}, this.$route.query, { query: undefined }) });
      }
    } else {
      // 검색 키워드 변수 및 쿼리 스트링에 적용
      this.searchKeyword = keyword;
      this.$router.push({ query: Object.assign({}, this.$route.query, { query: keyword }) });
    }
  }

  get searchPlaceholder() {
    let placeholder = '검색';
    const { name } = this.$route;
    if (name === 'ContentView' || name === 'DrawerInventoryItem') {
      placeholder = '재고에서 ' + placeholder;
    } else if (name === 'StatusView' || name === 'DrawerRequestItem') {
      placeholder = '요청에서 ' + placeholder;
      switch (this.$route.query.status) {
        case 'PENDING':
          placeholder = '신규 ' + placeholder;
          break;
        case 'APPROVED':
          placeholder = '승인 ' + placeholder;
          break;
        case 'ORDERED':
          placeholder = '주문 ' + placeholder;
          break;
        case 'RECEIVED':
          placeholder = '수령 ' + placeholder;
          break;
        case 'BACKORDERED':
          placeholder = '배송지연 ' + placeholder;
          break;
        case 'CANCELLED':
          placeholder = '취소 ' + placeholder;
          break;
      }
    }

    return placeholder;
  }

  beforeDestroy() {
    this.sortable = null;
  }
}
